const initialState = { isSuccessOpen: false, isErrorOpen: false };

export function notificationModals(state = initialState, action) {
  switch (action.type) {
    case 'OPEN_NOTIFICATION_MODAL':
      if (action.notificationType === 'success') {
        return { ...state, isSuccessOpen: true };
      } else if (action.notificationType === 'error') {
        return { ...state, isErrorOpen: true };
      }
      return state;
    case 'CLOSE_NOTIFICATION_MODAL':
      return { isSuccessOpen: false, isErrorOpen: false };
    default:
      return state;
  }
}
